function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#006699",
    d: "M 57.5,29.5 C 189.5,29.3333 321.5,29.5 453.5,30C 468.217,33.0497 477.383,41.883 481,56.5C 481.667,189.167 481.667,321.833 481,454.5C 477.422,469.077 468.256,477.91 453.5,481C 321.5,481.667 189.5,481.667 57.5,481C 42.7443,477.91 33.5776,469.077 30,454.5C 29.3333,321.833 29.3333,189.167 30,56.5C 33.7952,41.8701 42.9619,32.8701 57.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#67a2c1",
    d: "M 137.5,106.5 C 132.463,106.413 127.463,106.746 122.5,107.5C 125.186,106.009 128.186,105.343 131.5,105.5C 133.696,105.505 135.696,105.838 137.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 137.5,106.5 C 138.833,106.5 140.167,106.5 141.5,106.5C 144.939,108.204 148.605,109.538 152.5,110.5C 159.16,113.827 164.16,118.827 167.5,125.5C 171.035,135.06 171.368,144.726 168.5,154.5C 164.833,162.833 158.833,168.833 150.5,172.5C 148.597,172.796 146.93,173.463 145.5,174.5C 138.201,175.35 130.868,175.683 123.5,175.5C 121.485,174.076 119.152,173.41 116.5,173.5C 116.027,172.094 115.027,171.427 113.5,171.5C 104.634,167.126 98.8011,160.126 96,150.5C 95.5006,144.843 95.3339,139.176 95.5,133.5C 97.5848,131.316 98.5848,128.649 98.5,125.5C 101.5,119.167 106.167,114.5 112.5,111.5C 114.027,111.573 115.027,110.906 115.5,109.5C 117.898,109.741 119.898,109.074 121.5,107.5C 121.833,107.5 122.167,107.5 122.5,107.5C 127.463,106.746 132.463,106.413 137.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ea5c3",
    d: "M 141.5,106.5 C 145.708,106.677 149.374,108.01 152.5,110.5C 148.605,109.538 144.939,108.204 141.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9dc2d6",
    d: "M 121.5,107.5 C 119.898,109.074 117.898,109.741 115.5,109.5C 117.102,107.926 119.102,107.259 121.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9ac1d5",
    d: "M 115.5,109.5 C 115.027,110.906 114.027,111.573 112.5,111.5C 112.973,110.094 113.973,109.427 115.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4c7d9",
    d: "M 98.5,125.5 C 98.5848,128.649 97.5848,131.316 95.5,133.5C 95.4152,130.351 96.4152,127.684 98.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#87b5cd",
    d: "M 167.5,125.5 C 169.311,127.385 170.478,129.719 171,132.5C 171.667,138.5 171.667,144.5 171,150.5C 170.8,152.32 169.966,153.653 168.5,154.5C 171.368,144.726 171.035,135.06 167.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86b5cd",
    d: "M 113.5,171.5 C 115.027,171.427 116.027,172.094 116.5,173.5C 114.973,173.573 113.973,172.906 113.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#77abc7",
    d: "M 150.5,172.5 C 149.365,174.213 147.698,174.88 145.5,174.5C 146.93,173.463 148.597,172.796 150.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#76abc7",
    d: "M 116.5,173.5 C 119.152,173.41 121.485,174.076 123.5,175.5C 120.848,175.59 118.515,174.924 116.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#76aac6",
    d: "M 145.5,174.5 C 145.082,175.222 144.416,175.722 143.5,176C 136.654,176.821 129.987,176.654 123.5,175.5C 130.868,175.683 138.201,175.35 145.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#619ebf",
    d: "M 325.5,199.5 C 331.319,198.347 337.319,198.181 343.5,199C 346.851,199.057 349.851,199.891 352.5,201.5C 343.582,199.897 334.582,199.23 325.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 325.5,199.5 C 334.582,199.23 343.582,199.897 352.5,201.5C 356.961,202.056 361.294,203.223 365.5,205C 371.308,207.99 376.975,211.156 382.5,214.5C 384.833,217.5 387.5,220.167 390.5,222.5C 398.468,231.104 403.802,241.104 406.5,252.5C 406.259,254.898 406.926,256.898 408.5,258.5C 409.647,264.51 410.647,270.51 411.5,276.5C 411.5,319.833 411.5,363.167 411.5,406.5C 389.167,406.5 366.833,406.5 344.5,406.5C 344.667,366.499 344.5,326.499 344,286.5C 343.79,284.942 343.29,283.609 342.5,282.5C 342.5,282.167 342.5,281.833 342.5,281.5C 342.139,277.085 340.806,273.085 338.5,269.5C 334.218,261.338 327.551,256.005 318.5,253.5C 312.681,252.347 306.681,252.181 300.5,253C 298.509,253.374 296.842,254.207 295.5,255.5C 292.669,256.079 290.336,257.412 288.5,259.5C 284.833,261.167 282.167,263.833 280.5,267.5C 278.674,269.147 277.34,271.147 276.5,273.5C 273.374,277.556 272.041,282.223 272.5,287.5C 271.501,326.996 271.168,366.663 271.5,406.5C 249.5,406.5 227.5,406.5 205.5,406.5C 205.5,339.167 205.5,271.833 205.5,204.5C 227.5,204.5 249.5,204.5 271.5,204.5C 271.168,214.19 271.502,223.856 272.5,233.5C 273.919,232.995 274.585,231.995 274.5,230.5C 274.5,230.167 274.5,229.833 274.5,229.5C 274.833,228.5 275.5,227.833 276.5,227.5C 278.587,226.415 279.92,224.749 280.5,222.5C 285.719,215.273 292.386,209.94 300.5,206.5C 306.363,204.88 312.03,202.88 317.5,200.5C 320.385,200.806 323.052,200.473 325.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9bc1d6",
    d: "M 317.5,200.5 C 312.03,202.88 306.363,204.88 300.5,206.5C 305.667,203.332 311.334,201.332 317.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#82b4cd",
    d: "M 98.5,203.5 C 121.5,203.5 144.5,203.5 167.5,203.5C 167.5,271.5 167.5,339.5 167.5,407.5C 144.5,407.5 121.5,407.5 98.5,407.5C 98.5,339.5 98.5,271.5 98.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 99.5,204.5 C 121.833,204.5 144.167,204.5 166.5,204.5C 166.5,271.833 166.5,339.167 166.5,406.5C 144.167,406.5 121.833,406.5 99.5,406.5C 99.5,339.167 99.5,271.833 99.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0d9e5",
    d: "M 271.5,204.5 C 271.833,204.5 272.167,204.5 272.5,204.5C 272.334,213.506 272.5,222.506 273,231.5C 273.383,230.944 273.883,230.611 274.5,230.5C 274.585,231.995 273.919,232.995 272.5,233.5C 271.502,223.856 271.168,214.19 271.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#408cb2",
    d: "M 272.5,203.5 C 273.167,212.167 273.833,220.833 274.5,229.5C 274.5,229.833 274.5,230.167 274.5,230.5C 273.883,230.611 273.383,230.944 273,231.5C 272.5,222.506 272.334,213.506 272.5,204.5C 272.5,204.167 272.5,203.833 272.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d99bb",
    d: "M 382.5,214.5 C 386.167,216.167 388.833,218.833 390.5,222.5C 387.5,220.167 384.833,217.5 382.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afcede",
    d: "M 280.5,222.5 C 279.92,224.749 278.587,226.415 276.5,227.5C 277.08,225.251 278.413,223.585 280.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6ba4c2",
    d: "M 318.5,253.5 C 310.685,253.076 303.018,253.743 295.5,255.5C 296.842,254.207 298.509,253.374 300.5,253C 306.681,252.181 312.681,252.347 318.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ebad1",
    d: "M 406.5,252.5 C 408.074,254.102 408.741,256.102 408.5,258.5C 406.926,256.898 406.259,254.898 406.5,252.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5595b8",
    d: "M 288.5,259.5 C 286.167,262.5 283.5,265.167 280.5,267.5C 282.167,263.833 284.833,261.167 288.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#76aac6",
    d: "M 338.5,269.5 C 340.806,273.085 342.139,277.085 342.5,281.5C 340.589,277.767 339.256,273.767 338.5,269.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#478fb4",
    d: "M 276.5,273.5 C 276.54,276.425 275.707,279.091 274,281.5C 273.833,323.669 273.333,365.669 272.5,407.5C 272.5,367.5 272.5,327.5 272.5,287.5C 272.041,282.223 273.374,277.556 276.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81b2cc",
    d: "M 342.5,282.5 C 343.29,283.609 343.79,284.942 344,286.5C 344.5,326.499 344.667,366.499 344.5,406.5C 344.5,406.833 344.5,407.167 344.5,407.5C 343.788,365.99 343.121,324.323 342.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a8cadc",
    d: "M 272.5,203.5 C 272.5,203.833 272.5,204.167 272.5,204.5C 272.167,204.5 271.833,204.5 271.5,204.5C 249.5,204.5 227.5,204.5 205.5,204.5C 205.5,271.833 205.5,339.167 205.5,406.5C 227.5,406.5 249.5,406.5 271.5,406.5C 271.168,366.663 271.501,326.996 272.5,287.5C 272.5,327.5 272.5,367.5 272.5,407.5C 249.833,407.5 227.167,407.5 204.5,407.5C 204.5,339.5 204.5,271.5 204.5,203.5C 227.167,203.5 249.833,203.5 272.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91bcd3",
    d: "M 411.5,276.5 C 412.499,319.997 412.832,363.663 412.5,407.5C 389.833,407.5 367.167,407.5 344.5,407.5C 344.5,407.167 344.5,406.833 344.5,406.5C 366.833,406.5 389.167,406.5 411.5,406.5C 411.5,363.167 411.5,319.833 411.5,276.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1ff5e62e71e6ea20cb629cb9ec4e6079.svg";
export { ForwardRef as ReactComponent };